import { css } from '@emotion/css';
import React from 'react';
import { ConfirmButton } from '../buttons/ConfirmButton';
import { Dialog } from './Dialog';

interface ConfirmDialogProps {
  title: string;
  description: string;
  confirmLabel: string;
  onConfirmClick: () => void;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  title,
  description,
  confirmLabel,
  onConfirmClick
}) => {
  return (
    <Dialog title={title}>
      <>
        <p
          className={css`
            flex: 1 1 auto;
            display: flex;
            word-break: break-word;
            padding: 12px 0 32px;
            @media (max-width: 369px) {
              font-size: 14px;
            }
          `}
        >
          {description}
        </p>

        <div
          className={css`
            flex: 0 0 auto;
            padding: 0 0 4px;
          `}
        >
          <ConfirmButton onClick={onConfirmClick}>{confirmLabel}</ConfirmButton>
        </div>
      </>
    </Dialog>
  );
};
